/**
 * Embryo Transfer API Endpoints
 * Base URL: /api/v1/embro-transfers
 */

export class EmbroTransferAPI {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  /**
   * Create new Embryo Transfer
   * POST /api/v1/embro-transfers/:procedureId
   * payload: {
   *   irm_visits_id?: number,
   *   irm_contacts_id?: number,
   *   transfer: {...},
   *   detail: {...},
   *   embros: [...]
   * }
   */
  async createEmbroTransfer(procedureId, payload) {
    return this.apiClient.post(`/api/v1/embro-transfers/${procedureId}`, payload);
  }

  /**
   * Get Embryo Transfer by ID
   * GET /api/v1/embro-transfers/:transferId
   */
  async getEmbroTransfer(transferId) {
    return this.apiClient.get(`/api/v1/embro-transfers/${transferId}`);
  }

  /**
   * Get all Embryo Transfers for a Procedure
   * GET /api/v1/embro-transfers/procedure/:procedureId
   */
  async getEmbroTransfersByProcedure(procedureId) {
    return this.apiClient.get(`/api/v1/embro-transfers/procedure/${procedureId}`);
  }

  /**
   * Get Embryo Transfer Parameter Group
   * GET /api/v1/ivf/embro-transfer/params
   */
  async getEmbroTransferParameterGroup() {
    return this.apiClient.get('/api/v1/ivf/embro-transfer/params');
  }

  /**
   * Update Embryo Transfer
   * PUT /api/v1/embro-transfers/:transferId
   * payload: {
   *   transfer?: {...},
   *   detail?: {...},
   *   irm_visits_id?: number | null,
   *   irm_contacts_id?: number | null
   * }
   */
  async updateEmbroTransfer(transferId, payload) {
    return this.apiClient.put(`/api/v1/embro-transfers/${transferId}`, payload);
  }

  /**
   * Update Transferred Embryos
   * PUT /api/v1/embro-transfers/:transferId/embros
   */
  async updateTransferredEmbros(transferId, embrosData) {
    return this.apiClient.put(`/api/v1/embro-transfers/${transferId}/embros`, {
      embros: embrosData,
    });
  }

  /**
   * Delete Embryo Transfer
   * DELETE /api/v1/embro-transfers/:transferId
   */
  async deleteEmbroTransfer(transferId) {
    return this.apiClient.delete(`/api/v1/embro-transfers/${transferId}`);
  }

  /**
   * Get Embryo Transfer Detail Parameters
   * These are the parameter members for the transfer details form
   */
  getDetailParameterSlugs() {
    return {
      anasthesia: 'embro-transfer-anesthesia',
      position: 'embro-transfer-position',
      vaginal_discharge: 'embro-transfer-vaginal-discharge',
      cervix: 'embro-transfer-cervix',
      volsellum_used: 'embro-transfer-volsellum',
      dilator: 'embro-transfer-dilator',
      transfer: 'embro-transfer-difficulty',
      type_of_catheter: 'embro-transfer-catheter',
      mucus_on_catheter: 'embro-transfer-mucus',
      blood_on_catheter: 'embro-transfer-blood',
    };
  }
}
